import { render, staticRenderFns } from "./EditorMenu.vue?vue&type=template&id=4fde2d58"
import script from "./EditorMenu.vue?vue&type=script&lang=ts"
export * from "./EditorMenu.vue?vue&type=script&lang=ts"
import style0 from "./EditorMenu.vue?vue&type=style&index=0&id=4fde2d58&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports